import { render } from "./company-setting.vue?vue&type=template&id=8cd4b9a2"
import script from "./company-setting.vue?vue&type=script&lang=js"
export * from "./company-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__